<kodit-page>
  <kodit-table [tableConfig]="tableConfig" [paginatedData]="paginatedData" [chipItems]="chipItems" [isTableLoading]="isLoading"> </kodit-table>
</kodit-page>
